import React from 'react';
import FormsSetting from '../../components/Setting/Forms/FormsSetting';

const ManageForms = () => {
    return <FormsSetting />;
};

export default ManageForms;
